import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from "@angular/core";
import { SafeResourceUrlPipe } from "../../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { FilaDosColumnasComponent } from "../fila-dos-columnas/fila-dos-columnas.component";
import { AnimacionVideoComponent } from "../../animacion-video/animacion-video.component";
import { RouterLink } from "@angular/router";
import { NgClass, NgStyle, SlicePipe, DatePipe, NgIf, NgFor } from "@angular/common";
import { Subscription } from "rxjs";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";
import { Noticia } from "@src/app/models/interfaces/noticia.interface";

@Component({
  selector: "app-dos-columnas-multifilas",
  templateUrl: "./dos-columnas-multifilas.component.html",
  styleUrls: ["./dos-columnas-multifilas.component.css"],
  imports: [NgClass, NgStyle, RouterLink, AnimacionVideoComponent, FilaDosColumnasComponent, SlicePipe, DatePipe, KebabCasePipe, SafeResourceUrlPipe, SkeletonImageComponent, NgIf, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DosColumnasMultifilasComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() noticias = [];
  @Input() idStart: any;
  @Input() autorEmpresa;
  @Input() showFecha = true;
  nSub: Subscription;

  constructor() {}

  @ViewChildren("nombreAutor") nombres: QueryList<any>;

  ngOnInit(): void {}
  formatDate(obj) {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }

  ngOnDestroy(): void {
    if (this.nSub) this.nSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.comprobarNombres();
  }

  comprobarNombres() {
    this.nSub = this.nombres.changes.subscribe((c) => {
      c.toArray().forEach((nombreElement) => {
        const padre = nombreElement.nativeElement.parentElement;
        const fecha = padre.children[1];
        if (padre.offsetWidth < fecha.offsetWidth + nombreElement.nativeElement.offsetWidth) {
          this.recortaNombre(nombreElement);
        }
      });
    });
  }
  recortaNombre(nombreElement: ElementRef) {
    const nombreCompleto = nombreElement.nativeElement.innerText.trim().split(" ");
    if (nombreCompleto.length > 1) {
      for (let i = 1; i < nombreCompleto.length; i++) {
        nombreCompleto[i] = nombreCompleto[i].charAt(0).toUpperCase() + ".";
      }
      nombreElement.nativeElement.innerText = nombreCompleto.join(" ");
    }
  }

  trackByNoticia(index: number, noticia: Noticia) {
    return noticia.idVideo;
  }
}
